<template>
    <card bg="bg-dark text-white" title="Muestras a verificar">
        <div class="row">
            <div class="col-md-12 float-md-right">
                <div v-if="details.length > 0" class="mt-4" style="height: 40px; width: 100%">
                    <span style="float: right">
                        <button v-if="!request.allQualityValid" class="btn btn-success" @click="ValidAll">
                            <i class="fas fa-check"></i>
                            Validar Calidad de Todas las Muestras
                        </button>

                        <button class="btn btn-warning ml-2" @click="redoAll">
                            <i class="fas fa-undo-alt"></i>
                            Enviar todo a revisión de Componentes
                        </button>

                        <button v-if="!request.allQualityValid" class="btn btn-danger ml-2" @click="rejectAll">
                            <i class="fas fa-ban"></i>
                            Rechazar todo
                        </button>
                    </span>
                </div>
            </div>
        </div>
        <card v-if="detailsNew.length > 0" title="Nuevo Producto">
            <div class="table-responsive">
                <div v-for="item in detailsNew" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <span :id="'detailid-' + item.id" :data-detailid="item.id"
                            :data-validated="item.wineryValidatedAt != null ? 1 : 0" style="display: none"></span>
                        <div class="card-header">
							<div class="row">
								<div class="col-md-6">
									<h5 class="card-title d-inline"><b>VINO: {{ item.variety }}
                                        {{ item.valley }} {{ item.quality }}</b></h5>
								</div>
								<div class="col-md-6 text-right">
                                    <button v-if="!item.qualityValidationDate && !item.rejectToQuality && item.sampleDetailStage === 4" 
                                        class="btn btn-success" @click.prevent="valid(item.id)">
                                        <i class="fa fa-check"></i> Validar
                                    </button>
                                    <button v-if="!item.qualityValidationDate && !item.rejectToQuality && item.sampleDetailStage === 4" 
                                        class="btn btn-warning ml-2 mr-2" @click.prevent="redo(item.id)">
                                        <i class="fa fa-undo-alt"></i> Enviar a revisión de
                                        Componentes
                                    </button>
                                    <button v-if="!item.qualityValidationDate && !item.rejectToQuality && item.sampleDetailStage === 4" 
                                        class="btn btn-danger" @click.prevent="reject(item.id)">
                                        <i class="fas fa-times"></i> Rechazar
                                    </button>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
								</div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode" style="width: 20%">
                                                    Mezcla Comercial
                                                </th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">{{ item.comercialMix }} - {{ item.comercialMixCode }}</span>
                                                </td>
                                                <td>
													<span class="badge badge-info p-2">{{ item.variety }}</span> 
																										<span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
													<span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table
                                        class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Muestra Enológica</th>
                                            <th>Con Degustación</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <i v-if="item.wineSample" class="fa fa-check text-success"></i>
                                                <i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered"
                                            v-if="item.estimatedDeliveryDateOenology
                                            || item.deliveryDateOenology
                                            || item.wineryValidatedAt
                                            || item.qualityValidationDate
                                            || item.wineryDispatch
                                            || item.internalDispatchGuide"
                                        >                                       
                                        <tr class="thead-dark">
                                            <th v-if="item.estimatedDeliveryDateOenology">Entrega Estimada Enología</th>
                                            <th v-if="item.deliveryDateOenology">Entrega Enología</th>
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validacion de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.estimatedDeliveryDateOenology">
                                                <span class="badge badge-warning" style="font-size: 16px">{{
                                                    item.estimatedDeliveryDateOenologyString }}</span>
                                            </td>
                                            <td v-if="item.deliveryDateOenology">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.deliveryDateOenologyString }}</span>
                                            </td>
                                            <td v-if="item.wineryValidatedAt">
                                                <span class="badge badge-success"
                                                    style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.wineryDispatchString }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.status == 'Desp. Rechazado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo de rechazo:</b>
                                        {{ item.rejectionReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>
                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="changeIconCollapse(item.id)">Ver más
                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="3">Componentes Asociados</th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 16%">Tipo</th>
                                                <th style="width: 15%">Código</th>
                                                <th>Descripción</th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 22%">Capsula</th>
                                                <td>
                                                    <span v-if="item.capsuleCode">{{ item.capsuleCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>  
                                                </td>
                                                <td>
                                                     {{ item.capsuleName }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Tapa</th>
                                                <td>
                                                    <span v-if="item.cappingCode">{{ item.cappingCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>  
                                                </td>
                                                <td>{{ item.cappingName }}</td>
                                            </tr>
                                            <tr>
                                                <th>Caja</th>
                                                <td>
                                                    <span v-if="item.boxCode">{{ item.boxCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>  
                                                </td>
                                                <td>
                                                    {{ item.boxName }}
                                                </td>                            
                                            </tr>
                                            <tr>
                                                <th>Botella</th>
                                                <td>
                                                    <span v-if="item.bottleCode">{{ item.bottleCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>  
                                                </td>
                                                <td>
                                                    {{ item.bottleName }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Etiqueta</th>
                                                <td>
                                                    <span v-if="item.labelCode">{{ item.labelCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>     
                                                </td>
                                                <td>
                                                    {{ item.labelName }}
                                                </td>                                         
                                            </tr>
                                            <tr>
                                                <th>Contraetiqueta</th>
                                                <td>
                                                    <span v-if="item.backLabelCode">{{ item.backLabelCode }}</span>
                                                    <span v-else="" class="badge badge-info">No Establecido</span>  
                                                </td>
                                                <td>
                                                    {{ item.backLabelName }}
                                                </td>                                       
                                            </tr>                                            
                                        </thead>
                                    </table>
                                     <table class="table table-striped table-bordered">
                                        <tr class="thead-dark">
                                            <th colspan="2">Otro Semielaborado</th>
                                        </tr>
                                        <tr v-if="item.otherSemiElaborateCode">
                                            <td style="width: 22%">
                                                {{ item.otherSemiElaborateCode }}
                                            </td>
                                            <td style="width: 78%;">
                                                {{ item.otherSemiElaborateName }}
                                            </td>
                                        </tr>
                                        <tr v-else="">
                                            <td colspan="2" style="width: 73%">
                                                <span class="badge badge-info">No Establecido</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                                <div v-if="item.isNewComposition == true" class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="2">
                                                    Nueva Composición
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th>Variedad</th>
                                                <th>Porcentaje</th>
                                            </tr>

                                            <tr v-for="composition in item.compositionDetails" :key="composition.id">
                                                <td v-if="item.id ===
                                                    composition.requestCommercialSampleDetailID
                                                    ">
                                                    {{ composition.variety }}
                                                </td>

                                                <td v-if="item.id ===
                                                    composition.requestCommercialSampleDetailID
                                                    ">
                                                    {{ composition.percent }}%
                                                </td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-12" v-if="item.sampleDetailStage === 4">
                                    <table class="table table-stripped table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="3">Observaciones Adicionales</th>
                                            </tr>
                                            <tr v-if="item.requestDetailObservations">
                                                <th style="width: 18%">Fecha</th>
                                                <th style="width: 12%">Usuario</th>
                                                <th style="width: 70%">Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="observation in item.requestDetailObservations" :key="observation.id">
                                                <td>{{ observation.createdAtString }}</td>
                                                <td>{{ observation.email }}</td>
                                                <td>{{ observation.observation }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="row">
                                                        <div class="col-10">
                                                            <input class="form-control" :id="'observation-input-' + item.id"
                                                                type="text" />
                                                        </div>
                                                        <div class="col-2">
                                                            <button class="btn btn-success float-right"
                                                                @click="addObservation(item.id)">
                                                                <i class="fa fa-save"></i>
                                                                <span class="ml-2">Registrar Observación</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12" v-if="item.sampleDetailStage === 4">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>

                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles.filter(
                                                (x) => x.qualityFile === false
                                            )" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>

                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true"
                                                            class="fas fa-image"></i></span>

                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true"
                                                            class="fas fa-file-excel"></i></span>

                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos (Calidad)</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="doc in item.documentFiles.filter(
                                                (x) => x.qualityFile === true
                                            )" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>

                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true"
                                                            class="fas fa-image"></i></span>

                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true"
                                                            class="fas fa-file-excel"></i></span>

                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4">
                                                    <input :id="'file-input-' + item.id" type="file" />
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success" @click="uploadFile(item.id)">
                                                        <i class="fa fa-save"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>

        <card v-if="detailFinish.length > 0" title="Producto Terminado">
            <div class="table-responsive">
                <div v-for="item in detailFinish" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <div class="card-header">
							<div class="row">
								<div class="col-md-6">
									<h5 class="card-title d-inline"><b>SKU: {{ item.sku }}</b></h5>
								</div>
								<div class="col-md-6 text-right">
									<div :id="'options-butons-' + item.id">
                                        <button v-if="!item.qualityValidationDate && !item.rejectToQuality && item.sampleDetailStage === 4" 
                                            class="btn btn-success" @click.prevent="valid(item.id)">
                                            <i class="fa fa-check"></i> Validar
                                        </button>

                                        <button v-if="!item.qualityValidationDate && !item.rejectToQuality && item.sampleDetailStage === 4" 
                                            class="btn btn-warning ml-2 mr-2" @click.prevent="redo(item.id)">
                                            <i class="fa fa-undo-alt"></i> Enviar a revisión de
                                            Componentes
                                        </button>

                                        <button v-if="!item.qualityValidationDate && !item.rejectToQuality && item.sampleDetailStage === 4" 
                                            class="btn btn-danger" @click.prevent="reject(item.id)">
                                            <i class="fas fa-times"></i> Rechazar
                                        </button>
									</div>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
								</div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Sku</th>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode">Mezcla Comercial</th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.sku }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">
                                                        {{ item.comercialMix }} -   {{ item.comercialMixCode }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span> 
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Sku (Para Despacho)</th>
                                            <th>Muestra Enológica</th>
                                            <th>Con Degustación</th>
                                            <th>Requiere Trasvasije</th>
                                            <th>Vino No Real</th>
                                            <th>No Maquetar</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalSku }}</span>
                                            </td>
                                            <td>
                                                <i v-if="item.wineSample" class="fa fa-check text-success"></i>
                                                <i v-if="!item.wineSample" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
                                                <i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.notRealWine" class="fa fa-check text-success"></i>
                                                <i v-if="!item.notRealWine" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.notLayout" class="fa fa-check text-success"></i>
                                                <i v-if="!item.notLayout" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered"
                                        v-if="item.estimatedDeliveryDateOenology
                                            || item.deliveryDateOenology
                                            || item.wineryValidatedAt
                                            || item.qualityValidationDate
                                            || item.wineryDispatch
                                            || item.internalDispatchGuide"    
                                        >
                                        <tr class="thead-dark">
                                            <th v-if="item.estimatedDeliveryDateOenology">Entrega Estimada Enología</th>
                                            <th v-if="item.deliveryDateOenology">Entrega Enología</th>
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validación de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.estimatedDeliveryDateOenology">
                                                <span class="badge badge-warning" style="font-size: 16px">{{
                                                    item.estimatedDeliveryDateOenologyString
                                                }}</span>
                                            </td>
                                            <td v-if="item.deliveryDateOenology">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.deliveryDateOenologyString
                                                }}</span>
                                            </td>
                                            <td v-if="item.wineryValidatedAt">
                                                <span class="badge badge-success"
                                                    style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryDispatchString
                                                }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide
                                                }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.rejectionReason" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white"><b>Motivo de rechazo: </b> {{ item.rejectionReason }}</span>
                                </div>
                            </div>

                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>

                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>

                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id"
                                        aria-expanded="false" class="btn btn-info" data-toggle="collapse" role="button"
                                        style="width: 100%" @click="changeIconCollapse(item.id)">
                                        Ver Más
                                        <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                                    </a>
                                </div>
                            </div>
                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="3">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            Componentes Asociados
                                                        </div>
                                                        <div class="col-md-6 text-right">
                                                            Zona de venta:
                                                            <span class="ml-2">{{ item.saleZone }}</span>
                                                        </div>
                                                    </div>  
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <th style="width: 8%">Posición</th>
                                            <th style="width: 15%">Código</th>
                                            <th>Componente</th>
                                        </thead>
                                        <tr v-if="item.components.length === 0">
                                            <td colspan="2"><span class="badge badge-info">Sin Componentes Seleccionados</span>  </td>
                                        </tr>
                                        <tr v-for="lc in item.components" :key="lc.id">
                                            <td>{{ lc.componentPosition }}</td>
                                            <td style="width: 15%">{{ lc.c_sku }}</td>
                                            <td>{{ lc.d_sku }}</td>                                            
                                        </tr>

                                    </table>
                                    <table class="table table-striped table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="2">Semielaborado:</th>
                                            </tr>
                                        </thead>
                                        <tr>
                                            <td style="width: 15%">{{ item.semiElaborateCode }}</td>
                                            <td>{{ item.semiElaborateName }}</td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="2">Otro Semielaborado:</th>
                                            </tr>
                                        </thead>
                                        <tr v-if="item.otherSemiElaborateCode">
                                            <td >
                                                {{ item.otherSemiElaborateCode }}
                                            </td>
                                            <td>
                                                {{ item.otherSemiElaborateName }}
                                            </td>
                                        </tr>
                                        <tr v-else="">
                                            <td colspan="2">
                                                <span class="badge badge-info">No Establecido</span>  
                                            </td>                                            
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-6">
                                    <table v-if="item.requestSampleDetailForDispatch" class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="2">
                                                    Componentes Asignados por el Área de Despacho
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="2">
                                                    Zona de venta:
                                                    <span v-if="item.requestSampleDetailForDispatch.saleZoneName" class="ml-2">{{ item.requestSampleDetailForDispatch.saleZoneName }}</span>
                                                    <span v-else="" class="ml-2">{{ item.requestSampleDetailForDispatch.saleZoneCode }}</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <template v-if="item.requestSampleDetailForDispatch">
                                            <tr v-for="dc in item.requestSampleDetailForDispatch.requestSampleDetailForDispatchComponents" :key="dc.id">
                                                <td style="width: 15%">{{ dc.componentCode }}</td>
                                                <td>{{ dc.component }}</td>
                                            </tr>
                                        </template>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-12" v-if="item.sampleDetailStage === 4">
                                    <table class="table table-stripped table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="3">Observaciones Adicionales</th>
                                            </tr>
                                            <tr v-if="item.requestDetailObservations">
                                                <th style="width: 18%">Fecha</th>
                                                <th style="width: 12%">Usuario</th>
                                                <th style="width: 70%">Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="observation in item.requestDetailObservations"
                                                :key="observation.id">
                                                <td>{{ observation.createdAtString }}</td>
                                                <td>{{ observation.email }}</td>
                                                <td>{{ observation.observation }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="row">
                                                        <div class="col-10">
                                                            <input class="form-control"
                                                                :id="'observation-input-' + item.id" type="text" />
                                                        </div>
                                                        <div class="col-2">
                                                            <button class="btn btn-success float-right"
                                                                @click="addObservation(item.id)">
                                                                <i class="fa fa-save"></i>
                                                                <span class="ml-2">Registrar Observación</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12" v-if="item.sampleDetailStage === 4">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>

                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.documentFiles.filter(
                                                (x) => x.qualityFile === false
                                            )" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'"
                                                        class="text-danger"><i aria-hidden="true"
                                                            class="fas fa-file-pdf"></i></span>

                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true"
                                                            class="fas fa-image"></i></span>

                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true"
                                                            class="fas fa-file-excel"></i></span>

                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i
                                                            class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos (Calidad)</th>
                                            </tr>
                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="doc in item.doc in
                                                item.documentFiles.filter(
                                                    (x) => x.qualityFile === true
                                                )" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'"
                                                        class="text-danger"><i aria-hidden="true"
                                                            class="fas fa-file-pdf"></i></span>

                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true"
                                                            class="fas fa-image"></i></span>

                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true"
                                                            class="fas fa-file-excel"></i></span>

                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i
                                                            class="fas fa-file-word"></i></span>
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td colspan="4">
                                                    <input :id="'file-input-' + item.id" type="file" />
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success"
                                                        @click="uploadFile(item.id)">
                                                        <i class="fa fa-save"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>

        <card v-if="detailBottle.length > 0" title="Producto Guarda Botella">
            <div class="table-responsive">
                <div v-for="item in detailBottle" :key="item.id">
                    <div class="card mb-4 cardShadow">
                        <span :id="'detailid-' + item.id" :data-detailid="item.id"
                            :data-validated="item.wineryValidatedAt != null ? 1 : 0" style="display: none"></span>
                        <div class="card-header">
							<div class="row">
								<div class="col-md-6">
									<h5 class="card-title d-inline"><b>CÓDIGO: {{ item.sku }}</b></h5>
								</div>
								<div class="col-md-6 text-right">
									<div :id="'options-butons-' + item.id">
                                        <button v-if="!item.qualityValidationDate && !item.rejectToQuality && item.sampleDetailStage === 4"
                                             class="btn btn-success" @click.prevent="valid(item.id)">
                                            <i class="fa fa-check"></i> Validar
                                        </button>

                                        <button v-if="!item.qualityValidationDate && !item.rejectToQuality && item.sampleDetailStage === 4" 
                                        class="btn btn-warning ml-2 mr-2" @click.prevent="redo(item.id)">
                                            <i class="fa fa-undo-alt"></i> Enviar a revisión de
                                            Componentes
                                        </button>

                                        <button v-if="!item.qualityValidationDate && !item.rejectToQuality && item.sampleDetailStage === 4" 
                                        class="btn btn-danger" @click.prevent="reject(item.id)">
                                            <i class="fas fa-times"></i> Rechazar
                                        </button>
									</div>
								</div>
							</div>
						</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12 text-right">
									<div v-if="item.sampleDetailStage > 0" :id="'status-color-' + item.id">
										<h4>
											<b><span :class="'badge ribbon-h-' +item.statusColor" :id="'status-text-' + item.id">
												<i class="fa fa-info-circle mr-4"></i>Estado: {{ item.status }}
											</span></b>
										</h4>
									</div>
								</div>
                                <div class="col-md-12">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th>Código</th>
                                                <th>Marca</th>
                                                <th v-if="item.comercialMixCode">Mezcla Comercial</th>
                                                <th>Vino</th>
                                                <th>Botellas</th>
                                                <th>Etapa</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="font-size: 20px !important;">
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.sku }}</span>
                                                </td>
                                                <td><span class="badge badge-info p-2">{{ item.brand }}</span>
                                                </td>
                                                <td v-if="item.comercialMixCode">
                                                    <span class="badge badge-info p-2">{{ item.comercialMix }} - {{ item.comercialMixCode }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">{{ item.variety }}</span> 
                                                                                                        <span class="badge badge-info p-2 ml-1">{{ item.valley }}</span>
                                                    <span class="badge badge-info p-2 ml-1">{{ item.quality }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success p-2">{{ item.quantity }}</span>
                                                </td>
                                                <td>
                                                    <span class="badge badge-info p-2">
                                                        <i class="fa fa-info-circle"></i>
                                                        {{ item.stage }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <tr class="thead-dark text-center">
                                            <th>Con Degustación</th>
                                            <th>Requiere Trasvasije</th>
                                            <th>Con Cosecha Histórica/Próxima</th>
                                            <th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
                                        </tr>
                                        <tr class="text-center" style="font-size: 20px !important;">
                                            <td>
                                                <i v-if="item.withTasting" class="fa fa-check text-success"></i>
                                                <i v-if="!item.withTasting" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.requireTransfer" class="fa fa-check text-success"></i>
                                                <i v-if="!item.requireTransfer" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <i v-if="item.isHistoricalOrUpcoming" class="fa fa-check text-success"></i>
                                                <i v-if="!item.isHistoricalOrUpcoming" class="fa fa-times text-danger"></i>
                                            </td>
                                            <td>
                                                <span class="badge badge-success p-2">{{ item.finalHarvest }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered"
                                        v-if="item.wineryValidatedAt
                                            || item.qualityValidationDate
                                            || item.wineryDispatch
                                            || item.internalDispatchGuide"  
                                        >
                                        <tr class="thead-dark">
                                            <th v-if="item.wineryValidatedAt">Validación de Componentes</th>
                                            <th v-if="item.qualityValidationDate">Validación de Calidad</th>
                                            <th v-if="item.wineryDispatch">Despacho desde Bodega</th>
                                            <th v-if="item.internalDispatchGuide">N° Guía Bodega</th>
                                        </tr>
                                        <tr>
                                            <td v-if="item.wineryValidatedAt">
                                                <span class="badge badge-success"
                                                    style="font-size: 16px">{{ item.wineryValidatedAtString }}</span>
                                            </td>
                                            <td v-if="item.qualityValidationDate">
                                                <span class="badge badge-success" style="font-size: 16px">
                                                    {{ item.qualityValidationDateString }}
                                                </span>
                                            </td>
                                            <td v-if="item.wineryDispatch">
                                                <span class="badge badge-success" style="font-size: 16px">{{
                                                    item.wineryDispatchString
                                                }}</span>
                                            </td>
                                            <td v-if="item.internalDispatchGuide">
                                                <span class="badge badge-primary" style="font-size: 16px">{{
                                                    item.internalDispatchGuide
                                                }}</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div v-if="item.status == 'Desp. Rechazado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo de rechazo:</b>
                                        {{ item.rejectionReason }}
                                    </span>
                                </div>
                            </div>

                            <div v-if="item.status == 'Invalidado'" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo:</b>
                                        {{ item.rejectionWineryDispatchReason }}
                                    </span>
                                </div>
                            </div>

                            <div v-if="item.cancelledAt != null" class="card mb-4 bg-danger">
                                <div class="card-body">
                                    <span class="text-white">
                                        <b>Motivo Cancelación:</b> {{ item.cancelledReason }}
                                    </span>
                                </div>
                            </div>

                            <a :aria-controls="'collapse' + item.id" :href="'#collapse' + item.id" aria-expanded="false"
                                class="btn btn-info btn-block" data-toggle="collapse" role="button"
                                @click="ChangeIconCollapse(item.id)">Ver más

                                <i :id="'icon' + item.id" class="fas fa-angle-down"></i>
                            </a>

                            <div :id="'collapse' + item.id" class="row collapse multi-collapse mt-2">
                                <div class="col-md-6">
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark"> 
                                            <tr>
                                                <th colspan="3">Componentes Asociados</th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <tr v-if="item.capsuleName">
                                                <th>Capsula</th>
                                                <td style="width: 15%">{{ item.capsuleCode }}</td>
                                                <td>{{ item.capsuleName }}</td>
                                            </tr>
                                            <tr v-if="item.cappingName">
                                                <th>Tapa</th>
                                                <td>{{ item.cappingCode }}</td>
                                                <td>{{ item.cappingName }}</td>                                            
                                            </tr>
                                            <tr v-if="item.boxName">
                                                <th>Caja</th>
                                                <td>{{ item.boxCode }}</td>
                                                <td>{{ item.boxName }}</td>                                             
                                            </tr>
                                            <tr v-if="item.bottleName">
                                                <th>Botella</th>
                                                <td>{{ item.bottleCode }}</td>
                                                <td>{{ item.bottleName }}</td>
                                            </tr>
                                            <tr v-if="item.labelName">
                                                <th>Etiqueta</th>
                                                <td>{{ item.labelCode }}</td>
                                                <td>{{ item.labelName }}</td>
                                            </tr>
                                            <tr v-if="item.backLabelName">
                                                <th>Contraetiqueta</th>
                                                <td>{{ item.backLabelCode }}</td>
                                                <td>{{ item.backLabelName }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-6">
                                    <table v-if="item.requestSampleDetailForDispatch" class="table table-striped table-hover table-bordered">
                                        <thead class="thead-dark">
                                            <tr>
                                                <th colspan="3">
                                                    Componentes Asignados por el Área de Despacho
                                                </th>
                                            </tr>
                                        </thead>
                                        <thead class="thead-light">
                                            <template>
                                                <tr v-for="dc in item.requestSampleDetailForDispatch.requestSampleDetailForDispatchComponents" :key="dc.id">
                                                    <th style="width: 20%"> {{ dc.family }}</th>
                                                    <td style="width: 15%"> {{ dc.componentCode }} </td>
                                                    <td> {{ dc.component }} </td>
                                                </tr>
                                            </template>
                                        </thead>
                                    </table>
                                    <table class="table table-striped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th style="width: 25%">Obs. Preparación del Vino</th>
                                                <td>{{ item.preparationRemarks }}</td>
                                            </tr>
                                            <tr>
                                                <th>Glosa Sticker</th>
                                                <td>{{ item.stickerGloss }}</td>
                                            </tr>
                                            <tr>
                                                <th>Confección Packaging</th>
                                                <td>{{ item.confectionRemarks }}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="col-md-12" v-if="item.sampleDetailStage === 4">
                                    <table class="table table-stripped table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="3">Observaciones Adicionales</th>
                                            </tr>
                                            <tr v-if="item.requestDetailObservations">
                                                <th style="width: 18%">Fecha</th>
                                                <th style="width: 12%">Usuario</th>
                                                <th style="width: 70%">Observación</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="observation in item.requestDetailObservations" :key="observation.id">
                                                <td>{{ observation.createdAtString }}</td>
                                                <td>{{ observation.email }}</td>
                                                <td>{{ observation.observation }}</td>
                                            </tr>
                                            <tr>
                                                <td colspan="3">
                                                    <div class="row">
                                                        <div class="col-10">
                                                            <input class="form-control" :id="'observation-input-' + item.id"
                                                                type="text" />
                                                        </div>
                                                        <div class="col-2">
                                                            <button class="btn btn-success float-right"
                                                                @click="addObservation(item.id)">
                                                                <i class="fa fa-save"></i>
                                                                <span class="ml-2">Registrar Observación</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-md-12" v-if="item.sampleDetailStage === 4">
                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos</th>
                                            </tr>

                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="doc in item.documentFiles.filter(
                                                (x) => x.qualityFilter === false
                                            )" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>

                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true"
                                                            class="fas fa-image"></i></span>

                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true"
                                                            class="fas fa-file-excel"></i></span>

                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>

                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <table class="table table-stripped table-hover table-bordered">
                                        <thead class="thead-light">
                                            <tr>
                                                <th colspan="5">Documentos Adjuntos (Calidad)</th>
                                            </tr>

                                            <tr v-if="item.documentFiles.length > 0">
                                                <th style="width: 18%">Usuario</th>
                                                <th style="width: 12%">Fecha de Carga</th>
                                                <th style="width: 54%">Nombre del Archivo</th>
                                                <th style="width: 8%">Tipo de Archivo</th>
                                                <th style="width: 8%">Opciones</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr v-for="doc in item.documentFiles.filter(
                                                (x) => x.qualityFilter === true
                                            )" :key="doc.id">
                                                <td>{{ doc.email }}</td>
                                                <td>{{ doc.createdAtString }}</td>
                                                <td>{{ doc.fileName }}</td>
                                                <td style="font-size: 20px">
                                                    <span v-if="doc.fileExtension == '.pdf'" class="text-danger"><i
                                                            aria-hidden="true" class="fas fa-file-pdf"></i></span>

                                                    <span v-if="doc.fileExtension == '.jpg' ||
                                                        doc.fileExtension == '.png'
                                                        " class="text-info"><i aria-hidden="true"
                                                            class="fas fa-image"></i></span>

                                                    <span v-if="doc.fileExtension == '.xls' ||
                                                        doc.fileExtension == '.xlsx'
                                                        " class="text-success"><i aria-hidden="true"
                                                            class="fas fa-file-excel"></i></span>

                                                    <span v-if="doc.fileExtension == '.doc' ||
                                                        doc.fileExtension == '.docx'
                                                        " class="text-primary"><i class="fas fa-file-word"></i></span>
                                                </td>

                                                <td>
                                                    <button class="btn btn-sm btn-success mr-2"
                                                        @click="downloadFile(doc.id)">
                                                        <i class="fa fa-download"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4">
                                                    <input :id="'file-input-' + item.id" type="file" />
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success" @click="uploadFile(item.id)">
                                                        <i class="fa fa-save"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
    </card>
</template>

<script>
import { Get, Post, Put } from "@/helper/axios";
import $ from "jquery";

export default {
    props: [
        "details",
        "id",
        "component",
        "progressDispatch",
        "minDate",
        "request",
    ],
    data() {
        return {
            Put,
            Get,
            Post,
            apiUrl: this.$store.getters.apiUrl,
            detailId: 0,
            exist: false,
            listSelectSample: [],
            updateDispatch: {},
            rejectionReason: "",
            shippingDate: "",
            couriers: [],
            minDateArrived: "",
            sampleSendToRevision: [],
            stock: {}
        };
    },
    created() {
        this.minDateArrived = this.minDate;
    },
    methods: {
        changeIconCollapse(item) {
            if ($(`#icon${item}`).hasClass("fa-angle-down")) {
                $(`#icon${item}`).toggleClass("fa-angle-up");
            } else if ($(`#icon${item}`).hasClass("fa-angle-up")) {
                $(`#icon${item}`).toggleClass("fa-angle-down");
            }
        },
        changeIconTrackingCollapse(item) {
            if ($(`#iconTracking${item}`).hasClass("fa-angle-down")) {
                $(`#iconTracking${item}`).toggleClass("fa-angle-up");
            } else if ($("#iconTracking" + item).hasClass("fa-angle-up")) {
                $(`#iconTracking${item}`).toggleClass("fa-angle-down");
            }
        },
        uploadFile(detailId) {
            let form = new FormData();
            let doc = document.getElementById("file-input-" + detailId);
            form.append("detailId", detailId);
            if (doc) {
                doc = doc.files[0];
                form.append("fileBase", doc);
            }
            form.append("fromQuality", true);
            this.$store.commit("setLoading", true);
            this.Put(`${this.apiUrl}v1/documentfile`, form, () => {
                this.$store.commit("setLoading", false);
                window.toastr.success("Se ha cargado el documento correctamente.");
                location.reload();
            });
        },
        valid(id) {
            this.ValidQuality([id]);
        },
        ValidAll() {
            let list = [];
            this.details
                .filter((x) => x.sampleDetailStage == 4)
                .forEach(function (x) {
                    list.push(x.id);
                });
            this.ValidQuality(list);
        },
        ValidQuality(list) {
            this.$swal({
                title: "¿Desea validar la calidad de la muestra?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.value) {
                    this.$store.commit("setLoading", true);
                    this.Put(`${this.apiUrl}v1/requestsample/quality`, list, (res) => {
                        this.$store.commit("setLoading", false);
                        this.listSelectSample = [];
                        window.toastr.success(
                            "Se ha(n) validado calidad de la(s) muestra(s) correctamente"
                        );
                        if (res.data.allValid) {
                            this.$router.push(`/solicitudes/visualizar/${this.id}`);
                        } else {
                            this.$emit("validQuality");
                        }
                    });
                }
            });
        },
        showSendRevision() {
            $("#sendToOenologyFromQualityModal").modal("show");
        },
        redo(id) {
            this.redoQuality([id]);
        },
        redoAll() {
            let list = [];
            this.details
                .filter((x) => x.sampleDetailStage == 4)
                .forEach(function (x) {
                    list.push(x.id);
                });
            this.redoQuality(list);
        },
        redoQuality(list) {
            this.$swal({
                title: "¿Desea enviar a revision de componentes la o las muestras?",
                icon: "question",
                input: "text",
                inputPlaceholder: "Motivo de envio",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.Put(
                        `${this.apiUrl}v1/requestsample/quality/redo`,
                        { Ids: list, Message: result.value },
                        () => {
                            this.$store.commit("setLoading", true);
                            this.listSelectSample = [];
                            window.toastr.warning(
                                "Se ha enviado una muestra a revision de componentes"
                            );
                            //this.$router.push("/");
                            location.reload();
                        }
                    );
                }
            });
        },
        reject(id) {
            this.rejectQuality([id]);
        },
        rejectAll() {
            let list = [];
            this.details
                .filter((x) => x.sampleDetailStage == 4)
                .forEach(function (x) {
                    list.push(x.id);
                });
            this.rejectQuality(list);
        },
        rejectQuality(list) {
            this.$swal({
                title: "¿Desea rechazar la calidad de la o las muestras?",
                icon: "question",
                input: "text",
                inputPlaceholder: "Motivo de rechazo",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.Put(
                        `${this.apiUrl}v1/requestsample/quality/reject`,
                        { Ids: list, Message: result.value },
                        () => {
                            this.$store.commit("setLoading", true);
                            this.listSelectSample = [];
                            window.toastr.error("Se ha rechazado una de las muestras");
                            //this.$router.push("/");
                            location.reload();
                        }
                    );
                }
            });
        },
        addObservation(detailId) {
            this.$store.commit("setLoading", true);
            let obs = document.getElementById("observation-input-" + detailId);
            let data = {
                requestCommercialSampleDetailId: detailId,
                observation: obs.value
            };
            this.Post(`${this.apiUrl}v1/RequestDetailObservations`, data, () => {
                this.$store.commit("setLoading", false);
                window.toastr.success("Se ha registrado la Observación correctamente.");
                obs.value = '';
                this.$emit("updateObservations");
            });
        },
        showStockModal(type, sku, harvest) {
            this.stock = {}
            this.$store.commit("setLoading", true);
            let data = 'Sku=' + sku + '&Type=' + type
            if (harvest)
                data += '&Harvest=' + harvest
            this.Get(this.apiUrl + "v1/MasterItems/GetStock?" + data, (res) => {
                this.stock = res.data;
                this.$swal({
                    title: "Consulta de Stock",
                    html:   `<table class="table table-sm table-bordered text-left">
                                <tr>
                                    <th style="width: 160px">Tipo</th>
                                    <td>`+this.stock.materialDescription +`</td>
                                </tr>
                                <tr>
                                    <th>Sku</th>
                                    <td>`+this.stock.sku +`</td>
                                </tr>
                                <tr>
                                    <th>Descripción</th>
                                    <td>`+this.stock.skuDescription +`</td>
                                </tr>
                                <tr>
                                    <th>Cosecha (Año)</th>
                                    <td>`+this.stock.harvest +`</td>
                                </tr>
                                <tr>
                                    <th>Stock</th>
                                    <td>`+this.stock.stock +`</td>
                                </tr>
                                <tr>
                                    <th>Actualizado</th>
                                    <td>`+this.stock.updatedStockAtString +`</td>
                                </tr>
                            </table>`,
                    icon: "info",
                    confirmButtonColor: "#3085d6",
                    width: 800
                });
            });
            this.$store.commit("setLoading", false);
        },
    },
    computed: {
        detailsNew: function () {
            return this.details.filter((x) => x.requestTypeId === 1);
        },
        detailFinish: function () {
            return this.details.filter((x) => x.requestTypeId === 2);
        },
        detailBottle: function () {
            return this.details.filter((x) => x.requestTypeId === 3);
        },
        detailsNewNotQuality: function () {
            return this.details.filter(
                (x) => x.requestTypeId === 1 && !x.QualityValidationDate
            );
        },
        detailFinishNotQuality: function () {
            return this.details.filter(
                (x) => x.requestTypeId === 2 && !x.QualityValidationDate
            );
        },
        detailBottleNotQuality: function () {
            return this.details.filter(
                (x) => x.requestTypeId === 3 && !x.QualityValidationDate
            );
        },
    },
};
</script>
